import React, { useState } from "react";
import { Box, Flex, IconButton } from "@chakra-ui/react";

import { AvatarBox } from "./AvatarBox";
import { Logo } from "./Logo";
import { Navigation } from "./Navigation";
import { MdMenu, MdMenuOpen } from "react-icons/md";
import { CgMenuLeft } from "react-icons/cg";
import { FiMenu } from "react-icons/fi";

interface SidebarProps {
  collapse: boolean;
  onCollapse: () => void;
}

export const Sidebar = ({ collapse, onCollapse }: SidebarProps) => {

  return (
    <React.Fragment>
      <Box w="full">
        {
          collapse? 
          <Flex
          w="full"
          alignItems="center"
          justifyContent="center"
          flexDirection="row"
          gap={4}
        >
          <Logo collapse={collapse} />
          <IconButton
            aria-label="Menu Collapse"
            icon={collapse ? <FiMenu /> : <CgMenuLeft />}
            onClick={onCollapse}
            variant="ghost"
            size="lg"
            border='1px solid grey'
            borderStyle='dashed'
          />
        </Flex>:
          <>
            <Logo collapse={collapse}/>
            <IconButton
              aria-label="Menu Collapse"
              icon={collapse ? <FiMenu /> : <CgMenuLeft />}
              onClick={onCollapse}
              variant="ghost"
              size="md"
              marginLeft="1.5px"
            />
          </>
        }

        <Navigation collapse={collapse} />
      </Box>
      <AvatarBox collapse={collapse} />
    </React.Fragment>
  );
};